import { Icd10Code } from '@dreryk/egabinet-icd-dictionary-published-language-api';
import { VisitDiagnosisUpdateAdditionalInformationCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';
import { Choice } from '@dreryk/watermelon';

import { visitDetailsTranslationKeys } from '../../../../../../translations';

import { DiagnosisAdditionalInformationFormBean } from './DiagnosisAdditionalInformationForm.types';
import { OnDiagnosisAdditionalInformationChanged } from './DiagnosisAdditionalInformationModal.types';

type VisitDiagnosisUpdateAdditionalInformationActionRenderProps = {
   updateAdditionalInformation: (formData: DiagnosisAdditionalInformationFormBean) => Promise<void>;
};

type VisitDiagnosisUpdateAdditionalInformationActionProps = {
   children: (renderProps: VisitDiagnosisUpdateAdditionalInformationActionRenderProps) => JSX.Element;
   code: string;
   onSuccess: OnDiagnosisAdditionalInformationChanged;
   visitId: number;
};

export const VisitDiagnosisUpdateAdditionalInformationAction = (
   props: VisitDiagnosisUpdateAdditionalInformationActionProps
): JSX.Element => {
   const { executeAsync } = useCqrsCommand<void, DiagnosisAdditionalInformationFormBean>(
      (parameters) => {
         const command = new VisitDiagnosisUpdateAdditionalInformationCommand();

         command.additionalInformation = Choice.withUseDefaultIfNull(parameters.additionalInformation);
         command.code = Icd10Code.of(props.code);
         command.visitId = props.visitId;

         return command;
      },
      {
         onSuccess: (__, parameters) => {
            dispatchSnackbarPositiveEvent(
               visitDetailsTranslationKeys.diagnoses.diagnosisAdditionalInformation.modal
                  .successfullyAddedDiagnosisAdditionalInformation
            );
            props.onSuccess(parameters.additionalInformation);
         },
      }
   );

   return props.children({
      updateAdditionalInformation: executeAsync,
   });
};
